import { GlobalModalContextProvider } from "@/components/modal/context";
import { AuthContextProvider } from "@/context/auth-renderer/Auth.context";
import { SearchPage } from "@/features/search-page/SearchPage";
import { SearchPageContextProvider } from "@/features/search-page/context/searchPage.context";
import { SearchPageUrlSearchParams } from "@/features/search-page/models";
import { SearchParamsContextProviderV2 } from "@/shared/search-params-context";
import {
  GeneratedServerSideProps,
  generateGetServerSidePropsWithHandlers,
} from "@/utils/ssr-utils";

export default function Search({
  parsedSearchParams,
  defaultIsAuthenticated,
}: GeneratedServerSideProps) {
  return (
    <AuthContextProvider defaultIsAuthenticated={defaultIsAuthenticated}>
      <SearchParamsContextProviderV2
        schema={SearchPageUrlSearchParams}
        defaultValue={
          new URLSearchParams(parsedSearchParams as unknown as URLSearchParams)
        }
      >
        <SearchPageContextProvider>
          <GlobalModalContextProvider>
            <SearchPage />
          </GlobalModalContextProvider>
        </SearchPageContextProvider>
      </SearchParamsContextProviderV2>
    </AuthContextProvider>
  );
}

export const getServerSideProps = generateGetServerSidePropsWithHandlers();
